import Vue from 'vue';

Vue.component('aurora-wrapper', require('./AuroraWrapper').default);
Vue.component('aurora-header', require('./AuroraHeader').default);
Vue.component('aurora-body', require('./AuroraBody').default);
Vue.component('aurora-footer', require('./AuroraFooter').default);
Vue.component('aurora-layout', require('./AuroraLayout').default);